<!--
 Created by huangw on 2020/10/16.
 柱状图
-->
<template>
    <div :id="id" :style="echarStyle"></div>
</template>
<script>
  import * as echarts from "echarts";
  import Vue from 'vue'

  Vue.prototype.$echarts = echarts

  export default {
    name: 'MultiBarchart',
    props: {
      id: {
        type: String,
      },
      echarStyle: {},
    },
    data () {
      return {
        myChart: null,
        data1:[]
      }
    },
    mounted () {
      this.drawLine()
      window.addEventListener('resize', this.resize())
    },
    created () {
      const user = this.$ls.get('user')
    },
    beforeDestroy () {
      // 移除事件监听，防止内存泄漏
      window.removeEventListener('resize', this.resize())
    },
    methods: {
      //自适应宽度
      resize () {
        let that = this
        let timer = null
        return function () {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            // 检查图表实例是否存在
            if (that.myChart) {
              that.myChart.resize()
            }
          })
        }
      },
      refreshData (sourcesData,xAxisData,title) {
        // 获取当前图表配置项
        var option = this.myChart.getOption()

        // 定义颜色列表，为不同系列分配颜色
        const colorList = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de']

        // 将数据源映射为完整的系列配置
        // sourcesData 中每个对象可包含：
        // - name: 系列名称
        // - data: 数据数组
        // - unit: 单位（可选，默认为'元'，可设置为'个'等其他单位）
        option.series = sourcesData.map((item, index) => {
          return {
            ...item, // 保留原始数据的name和data
            type: 'bar', // 图表类型，bar表示柱状图
            barWidth: '30%', // 柱子宽度，占类目间距的20%
            // 柱子样式配置
            itemStyle: {
              color: colorList[index % colorList.length], // 从颜色列表中循环取色
              borderRadius: [4, 4, 0, 0], // 圆角半径，[上, 下, 左, 右]，只对顶部添加圆角
              borderWidth: 0, // 边框宽度，0表示无边框
            },
            // 高亮样式配置（鼠标悬停时的效果）
            emphasis: {
              itemStyle: {
                color: colorList[index % colorList.length], // 悬停时保持原色
                opacity: 0.8 // 透明度降低到80%
              },
              focus: 'series' // 聚焦模式，series表示高亮当前系列，淡化其他系列
            },
            // 数据标签配置（柱子顶部显示的数值）
            label: {
              show: true, // 显示数据标签
              position: 'top', // 标签位置，在柱子顶部
              fontSize: 11, // 标签字体大小
              color: '#666', // 标签文字颜色
              // 格式化标签内容，根据单位显示不同格式
              formatter: function(params) {
                const unit = item.unit || '元' // 获取单位，默认为'元'
                if (unit === '个') {
                  return params.value + '个' // 项目数量直接显示数字
                }
                if (params.value >= 10000) {
                  return (params.value / 10000).toFixed(2) + '万' // 金额超过1万显示为X.XX万
                }
                return params.value.toLocaleString() // 使用千分位分隔符
              }
            }
          }
        })
        // 获取当前图表配置
        // 从 option.series 中获取对应的 unit 属性
        const seriesConfig = option.series[0]
        // 更新X轴数据（部门名称）
        option.xAxis[0].data = xAxisData
        // 更新y轴单位名称
        if (seriesConfig && seriesConfig.unit){
          option.yAxis[0].name = `单位(${seriesConfig.unit})`
        }
        // 更新 tooltip 配置
        option.tooltip = {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#ddd',
          borderWidth: 1,
          textStyle: {
            color: '#333',
            fontSize: 14
          },
          formatter: function(params) {
            // 第一行显示部门名称（加粗）
            let result = `<div style="margin-bottom: 8px; font-weight: 600;">${params[0].name}</div>`

            // 遍历该部门的所有数据系列
            params.forEach(item => {
              const unit = (seriesConfig && seriesConfig.unit) || '元'
              // 如果是'元'或'万元'，显示¥前缀；其他单位显示后缀
              const prefix = unit === '元' || unit === '万元' ? '¥' : ''
              const suffix = unit === '元' || unit === '万元' ? '' : unit

              result += `<div style="margin: 4px 0;">
                <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: ${item.color}; margin-right: 8px;"></span>
                ${item.seriesName}: <span style="font-weight: 600; color: #1890ff;">${prefix}${item.value.toLocaleString()}${suffix}</span>
              </div>`
            })
            return result
          }
        }

        // 应用新配置到图表
        this.myChart.setOption(option)

        // 自适应调整图表大小
        this.myChart.resize()
      },
      drawLine () {
        // 基于准备好的dom，初始化echarts实例
        this.myChart = echarts.init(document.getElementById(this.id))
        // 绘制图表
        this.myChart.setOption({
          // 标题配置
          title: {
            text: '', // 标题文本，空字符串表示不显示
            show: false // 不显示标题（因为卡片已有标题）
          },
          // 图例配置（说明每种颜色代表的数据系列）
          legend: {
            orient: 'horizontal', // 图例排列方向，horizontal=水平排列
            top: 10, // 图例距离顶部的距离
            left: 'center', // 图例水平居中
            itemGap: 20, // 图例每项之间的间距
            textStyle: {
              fontSize: 14, // 图例文字大小
              color: '#666' // 图例文字颜色
            }
          },
          // 网格配置（绘图区域的边距）
          grid: {
            left: '3%', // 左边距
            right: '4%', // 右边距
            bottom: '3%', // 下边距
            top: '60px', // 上边距（为图例留出空间）
            containLabel: true // 包含坐标轴标签，防止标签溢出
          },
          // X轴配置（类别轴，显示部门名称）
          xAxis: [
            {
              type: 'category', // 轴类型，category表示类目轴
              axisTick: {
                alignWithLabel: true // 刻度线与标签对齐
              },
              axisLine: {
                lineStyle: {
                  color: '#e8e8e8' // 轴线颜色，浅灰色
                }
              },
              axisLabel: {
                color: '#666', // 标签文字颜色
                fontSize: 12, // 标签文字大小
                interval: 0, // 显示所有标签，不自动隐藏
                rotate: 0, // 标签旋转角度，0表示不旋转
                margin: 15 // 标签与轴线的距离
              }
            }
          ],
          // Y轴配置（数值轴，显示金额）
          yAxis: [
            {
              type: 'value', // 轴类型，value表示数值轴
              name: '单位(元)', // 轴名称
              nameTextStyle: {
                color: '#999', // 轴名称文字颜色
                fontSize: 12, // 轴名称文字大小
                padding: [0, 0, 0, 0] // 轴名称内边距
              },
              axisLine: {
                show: false // 不显示Y轴线条
              },
              axisTick: {
                show: false // 不显示Y轴刻度
              },
              splitLine: {
                lineStyle: {
                  color: '#f0f0f0', // 网格线颜色，浅灰
                  type: 'dashed' // 网格线类型，虚线
                }
              },
              axisLabel: {
                color: '#999', // 刻度标签文字颜色
                fontSize: 12, // 刻度标签文字大小
                // 格式化刻度标签，大额自动简化显示
                formatter: function(value) {
                  if (value >= 10000) {
                    return (value / 10000).toFixed(1) + '万' // 超过1万显示为X.X万
                  }
                  return value
                }
              }
            }
          ],
          // 系列列表（定义图表的数据和样式，初始为空，通过refreshData填充）
          series: [
          ]
        })
      },
    },
  }
</script>

<style lang="less" scoped>
</style>
